import { baseState } from './state'
import Vue from 'vue'

let setConfig = component => {
  let config = {
    content: ''
  }
  if (component.json && component.json.config) {
    if (component.json.config.length !== 0) {
      config = component.json.config
    }
  }
  if (component.json.baseComponent) {
    component.config = config
  } else {
    component.config = component.json
  }
}

let fixStringSubComponents = component => {
  if (component.components) {
    component.components.forEach((subComponent, index) => {
      if (typeof subComponent === 'string') {
        component.components[index] = {
          name: subComponent
        }
      } else {
        fixStringSubComponents(subComponent)
      }
    })
  }
}

const indexBy = 'uuid'

const mutations = {
  SET (state, components = []) {
    var newArr = {}
    components.forEach(component => {
      newArr[component[indexBy]] = component
    })
    state.componentList = newArr
  },

  ADD (state, component) {
    setConfig(component)
    fixStringSubComponents(component.json)
    state.componentList[component[indexBy]] = component
  },

  SET_NEW (state, uuid) {
    state.newComponent = state.componentList[uuid]
  },

  CLEAR_NEW (state) {
    state.newComponent = baseState().newComponent
  },

  REMOVE (state, component) {
    Vue.delete(state.componentList, component[indexBy])
  },

  SET_NEW_PROP (state, { prop, value }) {
    Vue.set(state.newComponent, prop, value)
  }
}

export default mutations
